module.exports = __webpack_public_path__ + "static/media/cvBillyLevin.d02ccef0.pdf";